var _circle, _g, _path, _g2, _g3, _path2, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnitedStatesVirginIslands(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#fcfcfc",
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffda44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m299.479 178.846c0-24.012-19.466-43.478-43.479-43.478s-43.479 19.466-43.479 43.478h-95.651c0 23.641 20.594 42.808 44.235 42.808h-1.424c0 23.643 19.164 42.811 42.809 42.811 0 20.933 15.034 38.327 34.889 42.045l-.111.25h37.465l-.111-.25c19.856-3.72 34.889-21.113 34.889-42.045 23.644 0 42.809-19.168 42.809-42.811h-1.426c23.641 0 44.236-19.167 44.236-42.808z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.887 302.324-26.958 60.863c14.224 5.782 29.771 8.996 46.072 8.996s31.848-3.213 46.071-8.996l-26.957-60.863z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m200.348 200.227v74.891c0 42.598 55.652 55.652 55.652 55.652s55.652-13.054 55.652-55.652v-74.891z",
    fill: "#f0f0f0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#338af3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m62.079 257.802 30.099 84.184 29.786-84.184h22.732l-43.426 111.304h-18.185l-43.737-111.304z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m411.826 369.106v-111.304h21.633v111.304z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#d80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m222.609 224.411v90.754c7.651 5.631 15.883 9.504 22.261 11.984v-102.738z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289.391 224.411v90.754c-7.651 5.631-15.883 9.504-22.261 11.984v-102.738z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m200.348 200.225h111.304v35.316h-111.304z",
    fill: "#0052b4"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null)), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedStatesVirginIslands);
export default __webpack_public_path__ + "static/media/united-states-virgin-islands.0eab408178872ba9b3c45b3aa04d8f93.svg";
export { ForwardRef as ReactComponent };